import React from "react";

interface CategoryStats {
  sun: number;
  moon: number;
  star: number;
  rest: number;
}

interface CategoryProps {
  categoryStats: CategoryStats | null;
}

const Category: React.FC<CategoryProps> = ({
  categoryStats,
}) => {
  const categoryValues = {
    sun: categoryStats?.sun || 0,
    moon: categoryStats?.moon || 0,
    star: categoryStats?.star || 0,
    rest: categoryStats?.rest || 0,
  };

  const totalCategory =
    categoryValues.sun +
    categoryValues.moon +
    categoryValues.star +
    categoryValues.rest;

  return (
    <div className="category-section">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <span className="mb-0 fw-bold">Category</span>
        <div className="d-flex align-items-center gap-3">
          <span className="fw-bold">Total: {totalCategory}</span>
        </div>
      </div>
      <div className="category-content">
            <div className="d-flex align-items-end justify-content-between w-100 px-3">
              {(() => {
                const maxBarHeight = 60;
                const minBarHeight = 4;
                const sunHeight =
                  totalCategory > 0 && categoryValues.sun > 0
                    ? Math.max(
                        (categoryValues.sun / totalCategory) * maxBarHeight,
                        minBarHeight
                      )
                    : 0;
                const moonHeight =
                  totalCategory > 0 && categoryValues.moon > 0
                    ? Math.max(
                        (categoryValues.moon / totalCategory) * maxBarHeight,
                        minBarHeight
                      )
                    : 0;
                const starHeight =
                  totalCategory > 0 && categoryValues.star > 0
                    ? Math.max(
                        (categoryValues.star / totalCategory) * maxBarHeight,
                        minBarHeight
                      )
                    : 0;
                const restHeight =
                  totalCategory > 0 && categoryValues.rest > 0
                    ? Math.max(
                        (categoryValues.rest / totalCategory) * maxBarHeight,
                        minBarHeight
                      )
                    : 0;

                return (
                  <>
                    <div className="d-flex align-items-end gap-2">
                      {sunHeight > 0 && (
                        <div
                          className="expert-color"
                          style={{
                            width: "4px",
                            height: `${sunHeight}px`,
                            flexShrink: 0,
                          }}
                        ></div>
                      )}
                      <div className="d-flex flex-column">
                        <span className="fw-bold">{categoryValues.sun}</span>
                        <span className="text-muted small">Sun</span>
                      </div>
                    </div>
                    <div className="d-flex align-items-end gap-2">
                      {moonHeight > 0 && (
                        <div
                          className="intermediate-color"
                          style={{
                            width: "4px",
                            height: `${moonHeight}px`,
                            flexShrink: 0,
                          }}
                        ></div>
                      )}
                      <div className="d-flex flex-column">
                        <span className="fw-bold">{categoryValues.moon}</span>
                        <span className="text-muted small">Moon</span>
                      </div>
                    </div>
                    <div className="d-flex align-items-end gap-2">
                      {starHeight > 0 && (
                        <div
                          className="advanced-color"
                          style={{
                            width: "4px",
                            height: `${starHeight}px`,
                            flexShrink: 0,
                          }}
                        ></div>
                      )}
                      <div className="d-flex flex-column">
                        <span className="fw-bold">{categoryValues.star}</span>
                        <span className="text-muted small">Star</span>
                      </div>
                    </div>
                    <div className="d-flex align-items-end gap-2">
                      {restHeight > 0 && (
                        <div
                          className="beginner-color"
                          style={{
                            width: "4px",
                            height: `${restHeight}px`,
                            flexShrink: 0,
                          }}
                        ></div>
                      )}
                      <div className="d-flex flex-column">
                        <span className="fw-bold">{categoryValues.rest}</span>
                        <span className="text-muted small">Rest</span>
                      </div>
                    </div>
                  </>
                );
              })()}
            </div>

      </div>
    </div>
  );
};

export default Category;
